import DeviceModule from "@/store/modules/device";
import { defineComponent, reactive } from "vue";
export default defineComponent({
  name: "SystemInfo",
  components: {},
  setup: function setup() {
    var ruleForm = reactive({
      appVersion: process.env.VUE_APP_VERSION,
      windowsAppVersion: DeviceModule.hardwareInfo && DeviceModule.hardwareInfo.desktopAppVersion ? DeviceModule.hardwareInfo.desktopAppVersion : ""
    });
    return {
      ruleForm: ruleForm
    };
  }
});